<div class="our-scrolling-visa">
  <!-- Scrolling Ticker Start -->
  <div class="scrolling-visa-box">
    <div class="scrolling-content">
      <span><img src="../assets/images/cross-icon.svg" alt="" />Dubai</span>
      <span><img src="../assets/images/cross-icon.svg" alt="" />Arabistan</span>
      <span><img src="../assets/images/cross-icon.svg" alt="" />Umre</span>
      <span><img src="../assets/images/cross-icon.svg" alt="" />Hac</span>
      <span><img src="../assets/images/cross-icon.svg" alt="" />Turistik</span>
      <span><img src="../assets/images/cross-icon.svg" alt="" />Bireysel</span>
      <span><img src="../assets/images/cross-icon.svg" alt="" />Ticari</span>
      <span><img src="../assets/images/cross-icon.svg" alt="" />Dubai</span>
      <span><img src="../assets/images/cross-icon.svg" alt="" />Arabistan</span>
      <span><img src="../assets/images/cross-icon.svg" alt="" />Umre</span>
      <span><img src="../assets/images/cross-icon.svg" alt="" />Hac</span>
      <span><img src="../assets/images/cross-icon.svg" alt="" />Turistik</span>
      <span><img src="../assets/images/cross-icon.svg" alt="" />Bireysel</span>
      <span><img src="../assets/images/cross-icon.svg" alt="" />Ticari</span>
    </div>

    <div class="scrolling-content">
      <span><img src="../assets/images/cross-icon.svg" alt="" />Dubai</span>
      <span><img src="../assets/images/cross-icon.svg" alt="" />Arabistan</span>
      <span><img src="../assets/images/cross-icon.svg" alt="" />Umre</span>
      <span><img src="../assets/images/cross-icon.svg" alt="" />Hac</span>
      <span><img src="../assets/images/cross-icon.svg" alt="" />Turistik</span>
      <span><img src="../assets/images/cross-icon.svg" alt="" />Bireysel</span>
      <span><img src="../assets/images/cross-icon.svg" alt="" />Ticari</span>
      <span><img src="../assets/images/cross-icon.svg" alt="" />Dubai</span>
      <span><img src="../assets/images/cross-icon.svg" alt="" />Arabistan</span>
      <span><img src="../assets/images/cross-icon.svg" alt="" />Umre</span>
      <span><img src="../assets/images/cross-icon.svg" alt="" />Hac</span>
      <span><img src="../assets/images/cross-icon.svg" alt="" />Turistik</span>
      <span><img src="../assets/images/cross-icon.svg" alt="" />Bireysel</span>
      <span><img src="../assets/images/cross-icon.svg" alt="" />Ticari</span>

    </div>
  </div>
  <!-- Scrolling Ticker End -->
</div>
<div class="container">
  <!-- Arabanı sat section -->
  <div class="des-section">
    <div class="header">
      <h2>3 Adımda Vize Al!</h2>
      <p><span class="brand-name">VizeAsist</span> ile bu kadar kolay!</p>
    </div>
    <div class="row steps">
      <div class="step col-sm-4 col-md- 4">
        <h3>01</h3>
        <div class="step-bottom">
          <div class="img1"><img src="../../../assets/images/country.svg" alt="Arabanın Bilgileri" /></div>
          <div class="step-txt">
            <p>Gitmek İstediğin Ülkeyi Seç <br /> </p>
          </div>
          <div class="vektor"><img src="../../../assets/vectors/Vector2.svg" alt="Vektor 2" /></div>
        </div>
      </div>

      <div class="step col-sm-4 col-md- 4">
        <h3>02</h3>
        <div class="step-bottom">
          <div class="img2"><img src="../../../assets/images/payment2.svg" alt="Güvenilir Ödeme" /></div>
          <div class="step-txt">
            <p>
              Formu Doldur<br />
              
            </p>
          </div>
          <div class="vektor"><img src="../../../assets/vectors/Vector2.svg" alt="Vektor 2" /></div>
        </div>
      </div>

      <div class="step col-sm-4 col-md- 4">
        <h3>03</h3>
        <div class="step-bottom">
          <div class="img3"><img src="../../../assets/images/seyahat2.svg" alt="Seyahat et" /></div>
          <div class="step-txt">
            <p>Ödemeni Yap ve <br /> Dakikalar İçerisinde Vizeni Al</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="blog-container">
  <div class="container">
    <!-- Blog Section -->
    <div class="row blog-box">
      <div><app-blog [count]="3"></app-blog></div>
    </div>
  </div>
</div>
<div class="container">
  <!-- sss section -->

  <div class="row sss">
    <div class="col-md-4">
      <div class="section-title">
      <svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 13 13" fill="none"><path d="M6.5 0C6.72067 3.49437 9.5056 6.27934 13 6.5C9.5056 6.72067 6.72067 9.5056 6.5 13C6.27934 9.5056 3.49437 6.72067 0 6.5C3.49437 6.27934 6.27934 3.49437 6.5 0Z" fill="#0c9"></path></svg>

        <h3 class="wow fadeInUp" style="visibility: visible; animation-name: fadeInUp">
          Merak ETTİKLERİNİZİN <a routerLink="/sikca-sorulan-sorular">Tümü<img src="../../../assets/images/arrow-right.svg" alt="" /></a>
        </h3>
      </div>
      <span class="sss-title">Sıkça<br />Sorulan<br />Sorular</span>
    </div>
    <div class="col-md-8"><app-frequently-asked-questions [count]="3"></app-frequently-asked-questions></div>
  </div>
</div>
<div class="container">
  <!-- Contact Section -->
  <app-subscribe></app-subscribe>
</div>
